import React from 'react';
import { Routes, Route } from 'react-router-dom';
import OffersIndex from './pages/OffersIndex';

const OffersRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<OffersIndex />} />
    </Routes>
  );
};

export default OffersRoutes;